
import React, { PureComponent } from 'react';
import { Card, Collapse, Table } from 'antd';
import { Container } from '../../../../components';
import { AppWrappperHOC } from '../../../Root/HOC';
import { StyledAuditCommittee } from '../StyledIPO';
import {
  AUDIT_COMMITTEE_COLUMN,
  AUDIT_COMMITTEE_DATA,
  COMPENSATION_COMMITTEE_DATA,
  CORPORATE_SOCIAL_RESPONSIBILITY_COMMITTEE_DATA,
  RISK_MANAGEMENT_COMMITTEE_DATA,
  STAKEHOLDERS_COMMITTEE_DATA,
} from './constants';

const { Panel } = Collapse;

class AuditCommitte extends PureComponent {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    return (
      <StyledAuditCommittee>
        <Container>
          <Card className="rounded card-padding-20">
            <h2 className="text-red">Board Committees</h2>
            <Collapse
              expandIconPosition="right"
              bordered={false}
              className="collapse-grill"
            >
              <Panel
                header={<strong className="font-16">Audit Committee</strong>}
                key="01"
              >
                <Table
                  columns={AUDIT_COMMITTEE_COLUMN}
                  dataSource={AUDIT_COMMITTEE_DATA}
                  pagination={false}
                  className="audit-table"
                />
              </Panel>
              <Panel
                header={<strong className="font-16">Nomination and Remuneration Committee/ Compensation Committee</strong>}
                key="02"
              >
                <Table
                  columns={AUDIT_COMMITTEE_COLUMN}
                  dataSource={COMPENSATION_COMMITTEE_DATA}
                  pagination={false}
                  className="audit-table"
                />
              </Panel>
              <Panel
                header={<strong className="font-16">Stakeholders Relationship Committee</strong>}
                key="03"
              >
                <Table
                  columns={AUDIT_COMMITTEE_COLUMN}
                  dataSource={STAKEHOLDERS_COMMITTEE_DATA}
                  pagination={false}
                  className="audit-table"
                />
              </Panel>
              <Panel
                header={<strong className="font-16">Corporate Social Responsibility Committee</strong>}
                key="04"
              >
                <Table
                  columns={AUDIT_COMMITTEE_COLUMN}
                  dataSource={CORPORATE_SOCIAL_RESPONSIBILITY_COMMITTEE_DATA}
                  pagination={false}
                  className="audit-table"
                />
              </Panel>
              <Panel
                header={<strong className="font-16">Risk Management Committee</strong>}
                key="05"
              >
                <Table
                  columns={AUDIT_COMMITTEE_COLUMN}
                  dataSource={RISK_MANAGEMENT_COMMITTEE_DATA}
                  pagination={false}
                  className="audit-table"
                />
              </Panel>
            </Collapse>
          </Card>
        </Container>
      </StyledAuditCommittee>
    );
  }
}

const component = AppWrappperHOC(AuditCommitte);

export { AuditCommitte };
export default component;



// WEBPACK FOOTER //
// client/containers/StaticPages/IPO/AuditCommittee/index.jsx